/* ============================================================
   artvision® · Cookie-Einwilligung
   Quelle der Wahrheit ist Shopifys Customer Privacy API: sie
   steuert alle App-Pixel (Google & YouTube, Meta, Klaviyo …).
   Zusätzlich bekommen Google Consent Mode, Clarity und der
   Meta-Pixel das Signal direkt. Eine Kopie der Wahl liegt in
   localStorage (av_consent), damit snippets/av-consent-head
   schon vor dem Laden der Pixel den richtigen Zustand setzt.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'av_consent';
  var VERSION = 1;
  var dialog = document.getElementById('av-consent');
  if (!dialog) return;

  var views = dialog.querySelectorAll('[data-av-consent-view]');
  var switches = dialog.querySelectorAll('[data-av-consent-cat]');

  function read() {
    try {
      var c = JSON.parse(localStorage.getItem(KEY) || 'null');
      return c && c.v === VERSION ? c : null;
    } catch (e) { return null; }
  }

  function write(c) {
    try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
  }

  function withPrivacy(cb) {
    var S = window.Shopify;
    if (S && S.customerPrivacy && S.customerPrivacy.setTrackingConsent) return cb(S.customerPrivacy);
    if (S && S.loadFeatures) {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        cb(err ? null : window.Shopify.customerPrivacy);
      });
      return;
    }
    cb(null);
  }

  function signal(c) {
    var a = c.analytics ? 'granted' : 'denied';
    var m = c.marketing ? 'granted' : 'denied';
    window.dataLayer = window.dataLayer || [];
    (function () { window.dataLayer.push(arguments); })('consent', 'update', {
      ad_storage: m, ad_user_data: m, ad_personalization: m, analytics_storage: a
    });
    if (typeof window.clarity === 'function') window.clarity('consentv2', { ad_Storage: m, analytics_Storage: a });
    if (typeof window.fbq === 'function') window.fbq('consent', c.marketing ? 'grant' : 'revoke');
  }

  function toShopify(c) {
    withPrivacy(function (cp) {
      if (!cp) return;
      cp.setTrackingConsent({
        analytics: !!c.analytics,
        marketing: !!c.marketing,
        preferences: !!c.preferences,
        sale_of_data: !!c.marketing
      }, function () {});
    });
  }

  function apply(choice) {
    var c = {
      v: VERSION,
      analytics: !!choice.analytics,
      marketing: !!choice.marketing,
      preferences: !!choice.preferences,
      ts: new Date().toISOString()
    };
    write(c);
    signal(c);
    toShopify(c);
    close();
    document.dispatchEvent(new CustomEvent('av:consent', { detail: c }));
  }

  function show(name) {
    for (var i = 0; i < views.length; i++) {
      views[i].hidden = views[i].getAttribute('data-av-consent-view') !== name;
    }
    if (name === 'settings') {
      var c = read() || {};
      for (var j = 0; j < switches.length; j++) {
        switches[j].checked = !!c[switches[j].getAttribute('data-av-consent-cat')];
      }
    }
    var title = dialog.querySelector('[data-av-consent-view="' + name + '"] [tabindex="-1"]');
    if (title) title.focus();
  }

  function open(view) {
    if (!dialog.open) {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.classList.add('av-consent-is-open');
    }
    show(view || 'intro');
  }

  function close() {
    if (dialog.open) {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }
    document.documentElement.classList.remove('av-consent-is-open');
  }

  // Ohne Entscheidung lässt sich der Dialog nicht wegdrücken (Esc).
  dialog.addEventListener('cancel', function (e) {
    if (!read()) e.preventDefault();
    else document.documentElement.classList.remove('av-consent-is-open');
  });

  dialog.addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t) return;
    if (t.hasAttribute('data-av-consent-show')) show(t.getAttribute('data-av-consent-show'));
    else if (t.hasAttribute('data-av-consent-accept')) apply({ analytics: true, marketing: true, preferences: true });
    else if (t.hasAttribute('data-av-consent-reject')) apply({});
    else if (t.hasAttribute('data-av-consent-save')) {
      var c = {};
      for (var i = 0; i < switches.length; i++) c[switches[i].getAttribute('data-av-consent-cat')] = switches[i].checked;
      apply(c);
    }
  });

  window.avConsent = { open: open, get: read };

  var stored = read();
  if (stored) {
    // Wahl liegt vor: Signale setzen; fehlt Shopifys Cookie (abgelaufen,
    // gelöscht), wird die gespeicherte Wahl still erneut übertragen.
    signal(stored);
    withPrivacy(function (cp) {
      if (!cp || !cp.currentVisitorConsent) return;
      var v = cp.currentVisitorConsent();
      if (v && v.analytics === '' && v.marketing === '' && v.preferences === '') toShopify(stored);
    });
  } else if (dialog.getAttribute('data-auto-open') === 'true') {
    open('intro');
  }
})();
